import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Mui
import { Box, Toolbar, Typography } from '@mui/material';
// 
import ContactsHeader from './ContactsHeader';
import ContactsList from './ContactsList';

const ContactsPage:FC = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Toolbar variant="dense">
        <Typography variant="h6">{t('pages.contacts.title')}</Typography>
      </Toolbar>
      <Box sx={{ py: 2, px: 4, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <ContactsHeader />
        <ContactsList />
      </Box>
    </Fragment>
  )
}

export default ContactsPage;
